<div class="daxa-dialog-inner">

    <!-- Header -->
    <div class="dialog-header d-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            <i class="ri-lock-password-line me-2"></i> Change Password
        </h5>
        <button mat-icon-button mat-dialog-close class="close-btn">
            <i class="ri-close-line"></i>
        </button>
    </div>

    <!-- Body -->
    <mat-dialog-content>
        <form [formGroup]="pwForm" class="change-pw-form">
            <!-- Current password -->
            <div class="mb-20">
                <mat-form-field appearance="fill">
                    <mat-label>Enter current password</mat-label>
                    <input matInput formControlName="old_password"
                           [type]="showOld ? 'text' : 'password'">
                    <button mat-icon-button matSuffix type="button"
                            (click)="showOld = !showOld">
                        <i [class]="showOld ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
                    </button>
                </mat-form-field>
            </div>

            <!-- New password -->
            <div class="mb-20">
                <mat-form-field appearance="fill">
                    <mat-label>Enter new password</mat-label>
                    <input matInput formControlName="new_password"
                           [type]="showNew ? 'text' : 'password'"
                           (input)="evaluateStrength($event)">
                    <button mat-icon-button matSuffix type="button"
                            (click)="showNew = !showNew">
                        <i [class]="showNew ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
                    </button>
                    <mat-error *ngIf="pwForm.get('new_password')?.hasError('minlength')">
                        Password must be at least 8 characters
                    </mat-error>
                </mat-form-field>

                <!-- Strength indicator -->
                <div class="strength-bar-wrap" *ngIf="strengthScore > 0">
                    <div class="strength-bar">
                        <div class="strength-fill"
                             [style.width.%]="strengthScore * 25"
                             [ngClass]="strengthClass">
                        </div>
                    </div>
                    <span class="strength-label" [ngClass]="strengthClass">
                        {{ strengthLabel }}
                    </span>
                </div>
            </div>

            <!-- Confirm password -->
            <div class="mb-20">
                <mat-form-field appearance="fill">
                    <mat-label>Confirm new password</mat-label>
                    <input matInput formControlName="confirm_password"
                           [type]="showConfirm ? 'text' : 'password'">
                    <button mat-icon-button matSuffix type="button"
                            (click)="showConfirm = !showConfirm">
                        <i [class]="showConfirm ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
                    </button>
                    <mat-error *ngIf="pwForm.get('confirm_password')?.hasError('mismatch')">
                        Passwords do not match
                    </mat-error>
                </mat-form-field>
            </div>

        </form>
    </mat-dialog-content>

    <!-- Footer -->
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close class="btn-cancel">Cancel</button>
        <button mat-button class="btn-save" (click)="submit()" [disabled]="saving">
            <span *ngIf="!saving"><i class="ri-check-line me-1"></i> Update Password</span>
            <span *ngIf="saving">Updating...</span>
        </button>
    </mat-dialog-actions>

</div>